<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const title = 'レーダーコンテンツ一覧'
const contents = [
  {
    title: '雨雲レーダー',
    link: 'https://weathernews.jp/onebox/radar/',
    file: 'https://gvs.weathernews.jp/onebox/img/topic/radar.webp'
  },
  {
    title: '雨雪レーダー',
    link: 'https://weathernews.jp/onebox/rainsnow/',
    file: 'https://gvs.weathernews.jp/onebox/img/common/menu/rainsnow.webp'
  },
  {
    title: '雷レーダー',
    link: 'https://weathernews.jp/onebox/thunder/',
    file: 'https://gvs.weathernews.jp/onebox/img/topic/thunder_radar.webp'
  },
  {
    title: '紅葉レーダー',
    link: 'https://weathernews.jp/koyo/radar/',
    file: 'https://gvs.weathernews.jp/onebox/img/common/menu/koyo_radar.webp'
  },
  {
    title: 'ゲリラ雷雨レーダー',
    link: 'https://weathernews.jp/guerrilla/',
    file: 'https://gvs.weathernews.jp/onebox/img/topic/guerrilla.webp'
  },
  {
    title: '世界の雨雲レーダー',
    link: 'https://weathernews.jp/onebox/tenki/world/radar/',
    file: 'https://gvs.weathernews.jp/onebox/img/common/menu/world_radar.webp'
  }
]
</script>

<template>
  <div class="topicList_box">
    <SectionTitle :title="title" />
    <div class="topicList">
      <a
        v-for="(item, index) in contents"
        :key="index"
        class="link"
        :href="item.link"
      >
        <p class="title">{{ item.title }}</p>
        <figure class="image">
          <img
            :src="item.file"
            width="165"
            height="131"
            alt=""
            loading="lazy"
          >
        </figure>
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.topicList_box {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.topicList {
  display: flex;
  padding-bottom: 4px;
  gap: 6px;
  overflow-x: scroll;
  margin-top: 10px;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: #438fec;
  }
  .link {
    display: flex;
    flex-direction: column;
    flex: 1;
    width: calc((100% - 18px) * .25);
    min-width: 157px;
    gap: 5px;
    padding: 10px;
    border-radius: 8px;
    border: solid 1px #ccc;
    background-color: #fff;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / .25);
  }
  .title {
    color: #101010;
    font-size: 15px;
    font-weight: bold;
    line-height: 15px;
  }
  .image {
    border-radius: 12px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  @media screen and (min-width: 830px) {
    .link {
      transition: box-shadow .2s ease-in-out;
      &:hover {
        box-shadow: 0 2px 6px 0 rgb(0 0 0 / .45);
      }
    }
    .image {
      img {
        height: auto;
      }
    }
  }
}
.main {
  .topicList {
    @media screen and (min-width: 830px) {
      .link {
        width: calc((100% - 18px) * .25);
      }
    }
  }
}
</style>
